import { Monitor } from "@mui/icons-material";
import React, { Component } from "react";
import Fade from "react-reveal";

const About = (props) => {

    if (!props.data) return null;

    const name = props.data.name;
    const moniImage = "images/about/" + props.data.moniImage;
    const mimiImage = "images/about/" + props.data.mimiImage;
    const bio = props.data.bio;
    const bioTwo = props.data.bioTwo;

    return (
      <section id="about">
        <Fade duration={1000}>
          <div className="row">
            <div className="three columns">
              <img
                className="st"
                src={moniImage}
                alt="Simeon Teremkov"
              />
              <span className="NaMe">Симеон Теремков</span>
              <br />
              <span>Софтуер</span>
            </div>

            <div className="nine columns main-col">
              <h2>За нас</h2>
              <p>{bio}</p>
            </div>
          </div>
          <div className="row" style={{marginTop: "20px"}}>
            <div className="three columns">
              <img
                className="mm"
                src={mimiImage}
                alt="Maria Malcheva"
              />
              <span className="NaMe">Мария Малчева</span>
              <br />
              <span>Уеб дизайн</span>
            </div>
            <div className="nine columns">
              <h2>За проекта</h2>
              <p>{bioTwo}</p>
            </div>
          </div>
        </Fade>
      </section>
    );
}

export default About;
